module.exports = __webpack_public_path__ + "img/truck-bolt.03600d28.svg";